/**
 * UserSettingsPage Store
 * Zustand store for managing user preferences state
 */

import { create } from 'zustand';
import type { UserPreferences } from '@/application/queries/userPreferences';

const initialState = {
  data: null as UserPreferences | null,
  loading: true,
  error: null as Error | null,
  saving: false,
  saveError: null as Error | null,
  saveSuccess: false,
};

interface UserSettingsState {
  data: UserPreferences | null;
  loading: boolean;
  error: Error | null;
  saving: boolean;
  saveError: Error | null;
  saveSuccess: boolean;

  setData: (data: UserPreferences) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: Error | null) => void;
  setSaving: (saving: boolean) => void;
  setSaveError: (error: Error | null) => void;
  setSaveSuccess: (success: boolean) => void;
  _reset: () => void;
}

export const useUserSettingsStore = create<UserSettingsState>((set) => ({
  ...initialState,

  setData: (data) => set({ data, loading: false, error: null }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error, loading: false }),
  setSaving: (saving) => set({ saving }),
  setSaveError: (saveError) => set({ saveError, saving: false }),
  setSaveSuccess: (saveSuccess) => set({ saveSuccess, saving: false }),

  _reset: () => set(initialState),
}));
